/* eslint-disable import/prefer-default-export */

export const FONT_VARIANT_CLASS_NAME = {
  S: 'body-small',
  M:  'body-medium',
  L: 'body-large',
  XL: 'body-extra-large',
};

export const processTerminationSignals = ['SIGHUP', 'SIGINT', 'SIGTERM', 'SIGQUIT'] as const;
export type ProcessTerminationSignals = typeof processTerminationSignals[number];
